import { DeleteOutlined } from '@ant-design/icons';
import { useAccess } from '@sitemax/smx-permission';

import { useModal } from 'hooks/useModal';
import { useAppDispatch } from 'utilities/hooks';
import { useAppSelector } from 'utilities/hooks';
import { bulkSoftDelete, refreshDocumentTreeLevels } from 'slices/documentsActions';
import { containingFoldersOf } from 'utilities/documentTree';
import { Category, Document } from 'interfaces/documents';

export const Delete = (
    rows: (Category | Document)[],
    fetchData: () => void
) => {
    const dispatch = useAppDispatch();
    const { openModal } = useModal();
    const { breadcrumbs } = useAppSelector((state) => state.documents);
    const isProjectDocument = breadcrumbs?.length > 0 ? breadcrumbs[breadcrumbs.length - 1].is_project_document : false;
    const canManage = useAccess(isProjectDocument ? ['files.project.manage'] : ['files.all.manage']);

    const bulkDelete = async () => {
        if (!rows) return;
        await dispatch(bulkSoftDelete(rows.map(item => {
            if ((item as Category).type === 'category') {
                return (item as Category).uuid;
            } else {
                return (item as Document).id;
            }
        })));

        dispatch(refreshDocumentTreeLevels(containingFoldersOf(rows)));

        fetchData();
    };

    if (!canManage) return null;

    return {
        key: 'Delete',
        label: 'Delete',
        onClick: () => {
            openModal('confirmationModal', {
                text: 'Are you sure want to delete items?',
            }, {
                onConfirm: () => {
                    bulkDelete();
                }
            });
        },
        icon: <DeleteOutlined />,
        disabled: !rows.length,
    };
};